import dayjs, { Dayjs } from 'dayjs';

export type CostCenterDetailPeriod = {
  childcareType?: string | null;
  valid?: { from?: Dayjs | string | null } | null;
};

const startOf = (period: CostCenterDetailPeriod): number =>
  period?.valid?.from ? dayjs(period.valid.from).valueOf() : -Infinity;

/**
 * The childcare type of the validity period that starts latest, to pre-fill a new period with.
 *
 * Comfort only: the backend carries the type forward on insert as well when the field is not sent.
 * But without the pre-fill the drawer opens on an empty field and invites the administrator to leave
 * it that way. The form holds `valid.from` as a dayjs object, so periods are compared on their moment,
 * not their text; one without a start sorts first.
 */
export const latestChildcareType = (
  details: CostCenterDetailPeriod[]
): string | null => {
  const latest = [...details].sort(
    (left, right) => startOf(left) - startOf(right)
  )[details.length - 1];
  return latest?.childcareType ?? null;
};
